import FindRecipientPersonaType from './FindRecipientPersonaType';
import { PeopleFeedbackState } from './PeopleFeedbackState';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';

export enum FindResultType {
    None,
    Cache,
    FindPeople,
    SearchDirectory,
    MixedCacheLive,
}

export enum DirectorySearchType {
    None,
    Auto,
    Manual,
}

interface FindControlViewState {
    queryString: string;
    findPeopleFeedbackManager: FeedbackManagerState;
    findResultSet: FindRecipientPersonaType[];
    findResultType: FindResultType;
    isSearching: boolean;
    directorySearchType: DirectorySearchType;
    inForceResolve?: boolean;
    currentRenderedQueryString?: string;
    peopleFeedbackState?: PeopleFeedbackState;
}

export default FindControlViewState;
